/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_Admin_MenuInputs */

const en_admin_sidebar_admin_menu = /** @type {(inputs: Admin_Sidebar_Admin_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin menu`)
};

const de_admin_sidebar_admin_menu = /** @type {(inputs: Admin_Sidebar_Admin_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Menü`)
};

/**
* | output |
* | --- |
* | "Admin menu" |
*
* @param {Admin_Sidebar_Admin_MenuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_admin_menu = /** @type {((inputs?: Admin_Sidebar_Admin_MenuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_Admin_MenuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_admin_menu(inputs)
	return en_admin_sidebar_admin_menu(inputs)
});